import { useEffect, useState } from "react"
import Cookies from "js-cookie"

const DatalayerPageView = ({ hostname, locale, slug, siteName, errorCode, errorMessage, videoProgress }) => {
  const [alreadyInit, setAlreadyInit] = useState(false)

  useEffect(() => {
    let lang = null
    let country = null
    if (locale) {
      let localeParts = locale.split("-")
      if (localeParts?.[0]) {
        lang = localeParts[0]
      }
      if (localeParts?.[1]) {
        country = localeParts[1]
      }
    }

    let environment = null
    if (hostname) {
      if (hostname.includes("localhost")) {
        environment = "local"
      } else if (
        hostname.includes("dev") ||
        hostname.includes("test") ||
        hostname.includes("preview")
      ) {
        environment = "dev"
      } else if (
        hostname.includes("stg") ||
        hostname.includes("stage")
      ) {
        environment = "stg"
      } else {
        environment = "prod"
      }
    }

    // let user_id = Cookies.get("_ga")
    let marketo_id = Cookies.get("_mkto_trk")
    let business_id = Cookies.get("_biz_uid")
    let contentful_id = Cookies.get("contentful_id")

    let franchise_name = null
    let division_name = null
    let subdivision_name = null

    franchise_name = document.querySelector('meta[name="franchise"]')?.content
    if (franchise_name === "undefined") {
      franchise_name = null
    }
    division_name = document.querySelector('meta[name="division"]')?.content
    if (division_name === "undefined") {
      division_name = null
    }
    subdivision_name = document.querySelector(
      'meta[name="subdivision"]'
    )?.content
    if (subdivision_name === "undefined") {
      subdivision_name = null
    }
    if (errorCode) {
      let previous_page = Cookies.get("prev_page") || null
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: "error",
        error_type: errorCode,
        error_message: errorMessage,
        previous_page: previous_page,
        current_page: window.location.pathname,
      })
    } else {
      let dataLayerObj = window?.dataLayer ? Object?.values(window?.dataLayer) : null;
      for (let key in dataLayerObj){
        // check dataLayer for an existing "dataLayer-initialized" event 
        if(dataLayerObj[key]["event"] && dataLayerObj[key]["event"] === "dataLayer-initialized"){
          setAlreadyInit(true);
          break;
        }
      }
      // we don't want to re-fire this event if <DataLayer> gets re-attached for a video modal.
      if(alreadyInit === false && !videoProgress) {
        Cookies.set("prev_page", window.location.pathname)
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: "dataLayer-initialized",
          page_url: slug,
          page_title: siteName,
          locale: locale,
          // I don't know what this is and I don't think it's in the state
          spa_page: null,
          content_category: null,
          franchise: franchise_name, // Needs work before sectors
          division: division_name, // Needs work before sectors
          subdivision: subdivision_name, // Needs work before sectors
          business_id: business_id, // taking a guess here
          marketo_id: marketo_id,
          contentful_id: contentful_id,
          salesforce_id: null, // Don't think this is tracked
          amplitude_id: null, // Don't think this is tracked
          language: lang,
          site_version: null, // I need a <meta tag>
          environment: environment, // I'd prefer a <meta tag> but it's fine
          hostname: hostname,
          luna_version: null, // I need a <meta tag>
          // User is not something the site tracks currently
          trimble_id: localStorage.getItem("user_info")
            ? JSON.parse(localStorage.getItem("user_info"))?.tid
            : null,
          user_id: null,
          user_type: null,
          user_preferences: null,
          user_purchase_history: null,
          entitlement_id: null,
          entitlement_status: null,
          partner_type: null, // Don't know what this is
          dealer_type: null, // Don't know what this is
          member_since: null, // Don't know what this is
          logged_in: localStorage.getItem("user_info") ? true : false,
          // I don't think this data is avaliable at this component level? Maybe it's in state?
          city: null, // Don't think this is tracked
          state: null, // Don't think this is tracked
          country: country,
          postal_code: null, // Don't think this is tracked
        })
        setAlreadyInit(true)
      }
    }
  }, [hostname, locale, slug, siteName, errorCode, errorMessage])
}

export default DatalayerPageView
